import { render, staticRenderFns } from "./contactMeasurement.vue?vue&type=template&id=2b265fc6&"
import script from "./contactMeasurement.vue?vue&type=script&lang=js&"
export * from "./contactMeasurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports